export default {
    syteLandingPage: `${process.env.baseUrl}/wyszukiwanie-obrazem`,
};
